import React, {Component} from 'react'
import {connect} from 'react-redux'
import styles from '../css/FJThumbnailContainer.module.less';
import FJLineThumbnail  from 'fj-components/FJLineThumbnail';

class FJThumbnailContainer extends Component {

  render() {
    let {sourceId, mediaList, children, style, audioImg, sourceStatus, sourceName} = this.props;
    let media = mediaList.find(m => m.id === sourceId);
    let thumbnail = audioImg || (media && media.thumbnail);

    return (
      <FJLineThumbnail style={style}
                       thumbnail={thumbnail}
                       sourceStatus={sourceStatus}
                       sourceName={sourceName}
                       linkClassName={styles.name}
                       linkBoxClassName={styles.box}

      >
        {children}
      </FJLineThumbnail>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    mediaList: state.media.mediaList,
  }
};

export default connect(mapStateToProps)(FJThumbnailContainer);
